module.exports = __webpack_public_path__ + "img/yellowIncident.f20f5c8b.svg";